<div class="auth-flex-columns">
  <div class="auth-inner-wrapper">
    <img
      (click)="closeDialog()"
      class="close-icon"
      src="./../../../../assets/images/icons/close.svg"
      alt="close-icon"
    />
    <div class="form-block">
      <div class="heading no-description">
        <h1 class="page-title">Sign in</h1>
      </div>
      <!--
                <button class="c-button facebook w-100 mb-8-px" pButton pRipple>
            <img class="btn-icon mr-4-px" src="./../../../../assets/images/icons/facebook.svg" alt="facebook-icon">
              <span>Sign in with facebook</span>
            </button>
            <button (click)="authService.googleAuth()" class="c-button google w-100" pButton pRipple>
              <img class="btn-icon mr-4-px"src="./../../../../assets/images/icons/google.svg" alt="google-icon">
                <span >Sign in with Google</span>
              </button>
              <p class="or-text">Or</p>
      -->

      <form [formGroup]="loginForm">
        <app-inline-input-control
          [type]="'email'"
          [control]="loginForm.controls[LoginFields.Email]"
          [label]="'Email address:'"
          [name]="LoginFields.Email"
        ></app-inline-input-control>
        <app-inline-input-control
          [type]="'password'"
          [control]="loginForm.controls[LoginFields.Password]"
          [label]="'Password:'"
          [name]="LoginFields.Password"
        ></app-inline-input-control>

        <app-checkbox-control
          [control]="staySignedIn"
          [name]="'staySignedIn'"
          [classess]="'justify-content-center mb-24-px'"
          [binary]="true"
          [label]="'Stay signed in'"
          [labelPosition]="'After'"
        ></app-checkbox-control>

        <button
          (click)="signIn()"
          [disabled]="!loginForm.valid"
          class="c-button secondary w-100"
          pButton
          pRipple
        >
          <span>Sign in</span>
          <img
            class="btn-icon ml-8-px"
            src="./../../../../assets/images/icons/arrow-right-white.svg"
            alt="sign-in"
          />
        </button>
        <div class="extra-links">
          <p class="line">
            <span
              >Don't have an account ?
              <a (click)="openRegisterDialog()">Create a new account</a></span
            >
          </p>
          <p class="line">
            <span
              >Forgot password ?
              <a (click)="openForgotPasswordDialog()">Reset password</a></span
            >
          </p>
        </div>
      </form>
    </div>
  </div>
  <div class="banner-container">
    <app-current-banner
      [minWidth]="380"
      [authDialogStyles]="true"
    ></app-current-banner>
  </div>
</div>
